module.exports = __webpack_public_path__ + "img/lock.28a6cfb9.svg";